import { Component, Input } from '@angular/core';

@Component({
    selector: 'div-placeholder-animation',
    template: `
        <div class="field-container">
            <div class="animation-container" [style.height]="heightValue" [style.width]="widthValue">
                <div class="animation"></div>
            </div>
        </div>
    `,
    styles: [
        `
            .field-container {
                padding: 0.5rem 0;
            }

            .animation-container {
                height: 2rem;
                position: relative;
                width: 100%;
                background-color: var(--agilent-gray-pale);
                z-index: 44;
                overflow: hidden;
                border-radius: 0;
            }

            .animation {
                position: absolute;
                left: -45%;
                height: 100%;
                width: 45%;
                background-image: linear-gradient(
                        to left,
                        rgba(251, 251, 251, .05),
                        rgba(251, 251, 251, .3),
                        rgba(251, 251, 251, .6),
                        rgba(251, 251, 251, .3),
                        rgba(251, 251, 251, .05)
                );
                background-image: -moz-linear-gradient(
                        to left,
                        rgba(251, 251, 251, .05),
                        rgba(251, 251, 251, .3),
                        rgba(251, 251, 251, .6),
                        rgba(251, 251, 251, .3),
                        rgba(251, 251, 251, .05)
                );
                background-image: -webkit-linear-gradient(
                        to left,
                        rgba(251, 251, 251, .05),
                        rgba(251, 251, 251, .3),
                        rgba(251, 251, 251, .6),
                        rgba(251, 251, 251, .3),
                        rgba(251, 251, 251, .05)
                );
                animation: loading 1s infinite;
                z-index: 45;
            }

            @keyframes loading {
                0% {
                    left: -45%;
                }
                100% {
                    left: 100%;
                }
            }
        `
    ]
})
export class PlaceholderAnimationComponent {
    @Input() widthValue;
    @Input() heightValue;
}

